@if (subscribeTimer > 0) {
  <div class="count-down-time">
    {{ subscribeTimer }}
  </div>
}
